__turbopack_context__.v({
  "className": "librebaskerville_f953a325-module__01T66G__className",
});
